module.exports = __webpack_public_path__ + "static/media/10-12.f78fc3a9.mp3";